/* scroll */
$(function() {
    var rightbutton = $('.rightbutton');
    var leftbutton = $('.leftbutton');
        //右へ
        rightbutton.on('click',function () {
        $('.scrollWrap').animate({
            scrollLeft: $('.scrollWrap').scrollLeft() + 400
        }, 500);
        return false;
        });
        //左へスクロールで表示
        $('.scrollWrap').scroll(function () {
            if($(this).scrollLeft() < $('.scrollList').width() - $('.scrollWrap').width()) {
                rightbutton.addClass('active');
            } else {
                rightbutton.removeClass('active');
            }
        });
        //左へ
        leftbutton.on('click',function () {
        $('.scrollWrap').animate({
            scrollLeft: $('.scrollWrap').scrollLeft() - 400
        }, 500);
        return false;
        });
        //右へスクロールで表示
        leftbutton.removeClass('active');
        $('.scrollWrap').scroll(function () {
            if($(this).scrollLeft() > 0) {
                leftbutton.addClass('active');
            } else {
                leftbutton.removeClass('active');
            }
        });
  });